import { CopyToClipboard } from '@festina-life/ui/actions'
import { useTranslate } from '@festina-life/ui/hooks'
import { useMemo } from 'react'

import type { ClipboardData } from '../../types/clipboard'
import type { SimpleTemplateField } from '../../types/templateModel'
import {
  toConfigurationFunctionValue,
  toServerTemplateFields,
} from '../../uiModels/transformers/toServerModelConverter'
import type { ChildAction } from '../stackableTable/types'
import {
  clearVersionInfo,
  isNonEmptyFunctionValue,
  isNonEmptySimpleTemplateField,
} from './fieldsHelpers'
import type { TemplateFieldChild } from './TemplateFieldsTable'

export const useCopyChildAction = (): ChildAction<TemplateFieldChild> => {
  const translate = useTranslate()

  return useMemo(
    () => ({
      actionId: 'copyChild',
      title: translate('templateViewer.actions.copy'),
      node: (data) => {
        if (
          isNonEmptySimpleTemplateField(data.value) ||
          isNonEmptyFunctionValue(data.value)
        ) {
          const clearedFieldData = clearVersionInfo(data.value)
          const clipboardData = isNonEmptySimpleTemplateField(data.value)
            ? toServerTemplateFields([
                clearedFieldData as SimpleTemplateField,
              ]).find(
                (property) =>
                  property.name === (data.value as SimpleTemplateField).name,
              )?.value
            : toConfigurationFunctionValue(data.value)

          if (clipboardData) {
            const copiedValue: ClipboardData = {
              source: 'template',
              data: clipboardData,
            }

            return (
              <CopyToClipboard
                copyValue={JSON.stringify(copiedValue)}
                iconSize="md"
              />
            )
          }
        }

        return null
      },
    }),
    [translate],
  )
}
